import React from 'react';
import { Panel } from 'rsuite';
import { OverallMetrics } from '@/types/primaryLedgerSnapshots';
import MetricCard from './MetricCard';

interface OverallResultsSectionProps {
  metrics: OverallMetrics;
}

const formatCurrency = (value: number): string => {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

const formatPercentage = (value: number): string => {
  return (value * 100).toFixed(1);
};

const formatInteger = (value: number): string => {
  return Math.round(value).toLocaleString('en-US');
};

const OverallResultsSection: React.FC<OverallResultsSectionProps> = ({ metrics }) => {
  return (
    <Panel
      header={<span className="text-lg font-semibold text-gray-900 dark:text-gray-100">Overall Results</span>}
      bordered
      className="mb-6"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <MetricCard
          label="Revenue"
          value={metrics.revenue}
          formatValue={formatCurrency}
          prefix="$"
        />

        <MetricCard
          label="Units"
          value={metrics.units}
          formatValue={formatInteger}
        />

        <MetricCard
          label="Gross Profit"
          value={metrics.grossProfit}
          formatValue={formatCurrency}
          prefix="$"
        />

        <MetricCard
          label="Profit Margin"
          value={metrics.profitMarginPercent}
          formatValue={formatPercentage}
          suffix="%"
        />
      </div>
    </Panel>
  );
};

export default OverallResultsSection;